"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Arrows = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
var _reactIntl = require("react-intl");
var _ChevronBack = _interopRequireDefault(require("@quintoandar/cozy-icons/ChevronBack"));
var _ChevronForward = _interopRequireDefault(require("@quintoandar/cozy-icons/ChevronForward"));
var _Arrow = _interopRequireDefault(require("./Arrow"));
var _messages = _interopRequireDefault(require("../messages"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var propTypes = process.env.NODE_ENV !== "production" ? {
  customLeftArrow: _propTypes["default"].elementType,
  customRightArrow: _propTypes["default"].elementType,
  customLeftArrowLabel: _propTypes["default"].object,
  customRightArrowLabel: _propTypes["default"].object,
  index: _propTypes["default"].number.isRequired,
  onChangeIndex: _propTypes["default"].func.isRequired,
  onClickRightArrowInLastPosition: _propTypes["default"].func,
  showArrows: _propTypes["default"].bool,
  slideCount: _propTypes["default"].number,
  visibleItems: _propTypes["default"].number,
  intl: _propTypes["default"].object.isRequired,
  outsideArrows: _propTypes["default"].bool.isRequired,
  paginationDelta: _propTypes["default"].number,
  bottomArrows: _propTypes["default"].bool
} : {};
var defaultProps = {
  customLeftArrow: _Arrow["default"],
  customRightArrow: _Arrow["default"],
  customLeftArrowLabel: _messages["default"].defaultLabelLeftArrow,
  customRightArrowLabel: _messages["default"].defaultLabelRightArrow,
  visibleItems: 1,
  paginationDelta: 1,
  bottomArrows: false
};
var onClickLeft = function onClickLeft(onChangeIndex, index, paginationDelta) {
  return function (e) {
    return onChangeIndex(e, index - paginationDelta);
  };
};
var onClickRight = function onClickRight(isLastPosition, onClickRightArrowInLastPosition, onChangeIndex, index, paginationDelta) {
  return function (e) {
    return isLastPosition ? onClickRightArrowInLastPosition() : onChangeIndex(e, index + paginationDelta);
  };
};
var Arrows = exports.Arrows = function Arrows(_ref) {
  var customLeftArrow = _ref.customLeftArrow,
    customRightArrow = _ref.customRightArrow,
    customLeftArrowLabel = _ref.customLeftArrowLabel,
    customRightArrowLabel = _ref.customRightArrowLabel,
    index = _ref.index,
    onChangeIndex = _ref.onChangeIndex,
    onClickRightArrowInLastPosition = _ref.onClickRightArrowInLastPosition,
    showArrows = _ref.showArrows,
    slideCount = _ref.slideCount,
    visibleItems = _ref.visibleItems,
    intl = _ref.intl,
    outsideArrows = _ref.outsideArrows,
    paginationDelta = _ref.paginationDelta,
    bottomArrows = _ref.bottomArrows;
  var LeftArrow = customLeftArrow;
  var RightArrow = customRightArrow;
  var lADisabled = index === 0;
  var isLastPosition = index >= slideCount - visibleItems;
  var rADisabled = onClickRightArrowInLastPosition ? false : isLastPosition;
  var arrowPosition = outsideArrows ? "calc(".concat(_js["default"].alias.spacing.xxlarge, " * -1)") : _js["default"].alias.spacing.xsmall;
  return [!lADisabled || showArrows ? /*#__PURE__*/_react["default"].createElement(LeftArrow, {
    "aria-label": intl.formatMessage(customLeftArrowLabel),
    onClick: onClickLeft(onChangeIndex, index, paginationDelta),
    key: "left-arrow",
    disabled: lADisabled,
    variant: "fixed",
    left: arrowPosition,
    icon: _ChevronBack["default"],
    bottomArrows: bottomArrows,
    outsideArrows: outsideArrows
  }) : null, !rADisabled || showArrows ? /*#__PURE__*/_react["default"].createElement(RightArrow, {
    "aria-label": intl.formatMessage(customRightArrowLabel),
    onClick: onClickRight(isLastPosition, onClickRightArrowInLastPosition, onChangeIndex, index, paginationDelta),
    key: "right-arrow",
    disabled: rADisabled,
    variant: "fixed",
    right: arrowPosition,
    icon: _ChevronForward["default"],
    bottomArrows: bottomArrows,
    outsideArrows: outsideArrows
  }) : null];
};
Arrows.displayName = 'Arrows';
Arrows.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
Arrows.defaultProps = defaultProps;
var _default = exports["default"] = (0, _reactIntl.injectIntl)(Arrows);